const PresetIntegrated = ({language , token}) => {
    const newPresetIframe = "https:" +
    window.process.env.URL_Preset
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_preset_display"
        src={newPresetIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default PresetIntegrated